import React from 'react';
import Header from '../components/Layout/Header';
import AgentChatWidget from '../components/Widget/AgentChatWidget';

const ChatPage: React.FC = () => {
  return (
    <div className="flex flex-col h-screen">
      <Header title="AI Legal Assistant" subtitle="Ask legal questions and get instant answers" />
      <div className="flex-1 overflow-hidden">
        <AgentChatWidget
          showSidebar={true}
          showHeader={true}
          height="100%"
        />
      </div>
    </div>
  );
};

export default ChatPage;
